import React, { PureComponent } from 'react';
import SelectBox from 'devextreme-react/select-box';

import CoreUtils from '../utils/CoreUtils';
import StringUtils from '../utils/StringUtils';

import SataConfigurationUtils from '../value-types/SataConfigurationUtils';

export default class SataConfigurationEditor extends PureComponent {
  constructor(props) {
    super(props);

    this.expressionNameListener = this.onExpressionNameChanged.bind(this);
    this.expressionTypeListener = this.onExpressionTypeChanged.bind(this);
    this.shapeProfileListener = this.onShapeProfileChanged.bind(this);
    this.marketTypeListener = this.onMarketTypeChanged.bind(this);
    this.resolutionStrategyListener = this.onResolutionStrategyChanged.bind(this);

    this.expressionTypes = SataConfigurationUtils.getExpressionTypeOptions();
    this.profileOptions = SataConfigurationUtils.getShapeProfileOptions();
    this.marketTypes = SataConfigurationUtils.getMarketTypes();
    this.resolutionStrategies = SataConfigurationUtils.getResolutionStrategies();

    this.expressionType = this.expressionTypes[0];
    this.shapeProfile = this.profileOptions[0];
    this.marketType = this.marketTypes[1];
    this.resolutionStrategy = this.resolutionStrategies[0].enumValue;
  }

  updateCompositeValues() {
    var sataValues = SataConfigurationUtils.deserializeValues(this.props.value);
    if (CoreUtils.isDefinedAndNotNull(sataValues)) {
      this.expressionName = sataValues.expressionName;
      this.expressionType = sataValues.expressionType;
      this.shapeProfile = sataValues.shapeProfile;
      this.marketType = sataValues.marketType;
      this.resolutionStrategy = sataValues.resolutionStrategy;
      this.enableOptionSelect = true;
    }
    else {
      this.expressionName = '';
      this.enableOptionSelect = false;
    }
  }

  render() {
    this.updateCompositeValues();

    return (
      <div className="pwx-sata-configuration-editor">
        <table><tbody>
          <tr>
            <td className="pwx-sata-configuration-label">Expression Name:</td>
            <td />
            <td className="pwx-sata-configuration-label">Expression Type:</td>
            <td />
            <td className="pwx-sata-configuration-label">Shape Profile:</td>
          </tr>
          <tr>
            <td>
              <input
                className="pwx-string-editor"
                disabled={this.props.disabled}
                onChange={this.expressionNameListener}
                type="text"
                placeholder="<None>"
                value={this.expressionName}
                width="100px"
              />
            </td>
            <td width="5" />
            <td>
              <SelectBox
                dataSource={this.expressionTypes}
                disabled={this.props.disabled || !this.enableOptionSelect}
                dropDownOptions={{
                  wrapperAttr: {
                    class: 'pwx-sata-configuration-options'
                  }
                }}
                elementAttr={{
                  class: 'pwx-sata-configuration-editor'
                }}
                inputAttr={{
                  class: 'pwx-sata-configuration-input'
                }}
                height="26px"
                onValueChanged={this.expressionTypeListener}
                showClearButton={false}
                value={this.enableOptionSelect ? this.expressionType : ''}
                width="145px"
              />
            </td>
            <td width="5" />
            <td>
              <SelectBox
                dataSource={this.profileOptions}
                disabled={this.props.disabled || !this.enableOptionSelect}
                dropDownOptions={{
                  wrapperAttr: {
                    class: 'pwx-sata-configuration-options'
                  }
                }}
                elementAttr={{
                  class: 'pwx-sata-configuration-editor'
                }}
                inputAttr={{
                  class: 'pwx-sata-configuration-input'
                }}
                height="26px"
                onValueChanged={this.shapeProfileListener}
                showClearButton={false}
                value={this.enableOptionSelect ? this.shapeProfile : ''}
                width="105px"
              />
            </td>
          </tr>
          <tr height="3" />
        </tbody></table>
        <table><tbody>
          <tr>
            <td className="pwx-sata-configuration-label">Market Type:</td>
            <td />
            <td className="pwx-sata-configuration-label">Resolution Strategy:</td>
          </tr>
          <tr>
            <td>
              <SelectBox
                dataSource={this.marketTypes}
                disabled={this.props.disabled || !this.enableOptionSelect}
                dropDownOptions={{
                  wrapperAttr: {
                    class: 'pwx-sata-configuration-options'
                  }
                }}
                elementAttr={{
                  class: 'pwx-sata-configuration-editor'
                }}
                inputAttr={{
                  class: 'pwx-sata-configuration-input'
                }}
                height="26px"
                onValueChanged={this.marketTypeListener}
                showClearButton={false}
                value={this.enableOptionSelect ? this.marketType : ''}
                width="100px"
              />
            </td>
            <td width="5" />
            <td>
              <SelectBox
                dataSource={this.resolutionStrategies}
                disabled={this.props.disabled || !this.enableOptionSelect}
                displayExpr="displayName"
                dropDownOptions={{
                  wrapperAttr: {
                    class: 'pwx-sata-configuration-options'
                  }
                }}
                elementAttr={{
                  class: 'pwx-sata-configuration-editor'
                }}
                inputAttr={{
                  class: 'pwx-sata-configuration-input'
                }}
                height="26px"
                onValueChanged={this.resolutionStrategyListener}
                showClearButton={false}
                value={this.enableOptionSelect ? this.resolutionStrategy : ''}
                valueExpr="enumValue"
                width="260px"
              />
            </td>
          </tr>
        </tbody></table>
      </div>
    );
  }

  onExpressionNameChanged(event) {
    this.expressionName = event.target.value;
    this.handleValueEditChange();
  }

  onExpressionTypeChanged(event) {
    if (!this.enableOptionSelect)
      return;

    this.expressionType = event.value
    this.handleValueEditChange();
  }

  onShapeProfileChanged(event) {
    if (!this.enableOptionSelect)
      return;

    this.shapeProfile = event.value;
    this.handleValueEditChange();
  }

  onMarketTypeChanged(event) {
    if (!this.enableOptionSelect)
      return;

    this.marketType = event.value;
    this.handleValueEditChange();
  }

  onResolutionStrategyChanged(event) {
    if (!this.enableOptionSelect)
      return;

    this.resolutionStrategy = event.value;
    this.handleValueEditChange();
  }

  handleValueEditChange() {
    var value = !StringUtils.isNullOrWhitespace(this.expressionName)
      ? SataConfigurationUtils.serializeValues(
        this.expressionName,
        this.expressionType,
        this.shapeProfile,
        this.marketType,
        this.resolutionStrategy
      )
      : '';

    if (CoreUtils.isDefinedAndNotNull(this.props.onValueChanged))
      this.props.onValueChanged(this.props.name, value);
  }
}